/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

import store from '@/store'
import { getToken, types, setToken } from '@/utils/Token'
import { Dialog, Toast } from 'vant'
import { judgeUserAgent } from '@/utils/judgeUserAgent'
import weChatpostMessage from '@/utils//weChatpostMessage.js'
import fetchData from './fetchData'

import { passRouteHandle } from './utils/passRoute'
import { locationHandle } from './utils/locationHandle'

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 浏览器前进、后退优先使用 Vue Router 保存的位置
    if (savedPosition) return savedPosition

    if (to.meta.keepScroll !== true) {
      return { x: 0, y: 0 }
    }

    return (
      scrollPositions.get(to.fullPath) || {
        x: 0,
        y: 0
      }
    )
  }
})

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch((err) => err)
// }

// VueRouter.prototype.replace = function replace(location) {
// 	return originalPush.call(this, location).catch((err) => err)
// }

const loginUrl = '/login'
const needAuth =
  process.env.VUE_APP_NEED_AUTH == 'true' ? true : false

const { getAuth } = weChatpostMessage()

function getMiniProgamAuth({ data = {}, routerTo = '' }) {
  const result = getAuth({ data, routerTo })
  // setToken({
  //   Token: result.token,
  //   Refresh_token: result.refresh_token,
  //   Refresh_token_expiresat: result.refresh_token_expiresat,
  //   Expiresat: result.expiresat
  // })
}

// 小程序数据处理
const miniProgramDataHandle = data => {
  const datas = JSON.parse(decodeURIComponent(data))
  if (datas.action === 'getAuth') {
    setToken({
      Token: datas.data.token,
      Refresh_token: datas.data.refresh_token,
      Refresh_token_expiresat:
        datas.data.refresh_token_expiresat,
      Expiresat: datas.data.expiresat
    })
  }
}

window.addEventListener('popstate', function(event) {
  event.preventDefault()
  // 可以选择显示一个警告或者其他提示信息
  //  alert('无法返回上一页，继续操作！')
})

router.beforeEach(async (to, from, next) => {
  const isPassRoute = passRouteHandle(to, from, next)
  const locationRedirect = await locationHandle(to)
  if (locationRedirect) {
    next(locationRedirect)
    return
  }

  if (isPassRoute) {
    next()
  } else {
    if (to.meta.noLogin && !needAuth) {
      next()
    } else {
      if (
        getToken(types.Token) &&
        getToken(types.Token) !== null
      ) {
        // 异步获取用户信息，不阻塞路由跳转
        fetchData(to, from).catch(err => {
          console.error('获取用户数据失败:', err)
        })
        next()
      } else {
        // if (judgeUserAgent('miniProgram')) {
        // getAuth({ routerTo: to.fullPath })
        // const result = getMiniProgamAuth({
        //   routerTo: to.fullPath
        // })
        // } else {
        const fullPathString = encodeURIComponent(
          to.fullPath
        )
        if (to.path === loginUrl) {
          next()
        } else {
          if (needAuth) {
            // 需要登录并且带重定向参数
            next(`/login?redirect=${fullPathString}`)
            // next(`/login?${}`)
            Toast('请登录')
          } else {
            Dialog.confirm({
              title: '请先登录'
            }).then(() => {
              next(`/login?redirect=${fullPathString}`)
            })
          }
        }
      }
    }
  }
})

// 设置页面缓存
router.afterEach(to => {
  to.matched.forEach(route => {
    if (route.meta.keepAlive && route.name) {
      store.commit('cacheView/ADD_CACHED_VIEW', route.name)
    }
  })
})

export default router
